var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('section', {
    staticClass: "Boxtype"
  }, [_c('div', {
    staticClass: "animated fadeInDown"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-12 mb-1"
  }, [_c('b-tabs', [_c('b-tab', {
    attrs: {
      "title": _vm.$t('packingb2b.pickingBox')
    },
    on: {
      "click": function($event) {
        _vm.tabChanged(1)
      }
    }
  }, [_c('div', {
    staticClass: "card-header filter_main",
    staticStyle: {
      "display": "flex",
      "justify-content": "space-between"
    }
  }, [_c('i', {
    directives: [{
      name: "b-toggle",
      rawName: "v-b-toggle.collapse1",
      modifiers: {
        "collapse1": true
      }
    }],
    staticClass: " fa fa-filter filter",
    attrs: {
      "data-toggle": "collapse",
      "aria-expanded": "true"
    }
  }), _vm._v(" "), _c('a', {
    staticClass: "btn-setting d-sm-down-none",
    on: {
      "click": _vm.addNewBox
    }
  }, [_c('i', {
    staticClass: "fa fa-plus-square-o fa-lg",
    staticStyle: {
      "padding-right": "10px"
    }
  })])]), _vm._v(" "), _c('b-collapse', {
    attrs: {
      "visible": "",
      "id": "collapse1"
    }
  }, [_c('b-card', [_c('div', {
    staticClass: "card-body1"
  }, [_c('form', {
    staticClass: "form-horizontal",
    attrs: {
      "action": "",
      "method": "post"
    }
  }, [_c('div', {
    staticClass: "form-group row"
  }), _vm._v(" "), _c('div', {
    staticClass: "form-group row"
  }, [_c('div', {
    staticClass: "col-md-3"
  }, [_c('b-form-fieldset', [_c('label', [_vm._v(_vm._s(_vm.$t('boxList.boxType')))]), _vm._v(" "), _c('b-input-group', {
    attrs: {
      "left": "<i class='fa fa-cube'></i>"
    }
  }, [_c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.boxtypesearch),
      expression: "boxtypesearch"
    }],
    staticClass: "form-control",
    class: {
      'form-control': true,
      'error': _vm.errors.has('boxtypesearch')
    },
    attrs: {
      "name": "boxtypesearch"
    },
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.boxtypesearch = $event.target.multiple ? $$selectedVal : $$selectedVal[0]
      }
    }
  }, [_c('option', {
    attrs: {
      "selected": "",
      "disabled": "",
      "value": ""
    }
  }, [_vm._v(_vm._s(_vm.$t('boxList.boxTypePlaceHolder')))]), _vm._v(" "), _vm._l((_vm.listBoxtypeData), function(box_obj) {
    return _c('option', {
      domProps: {
        "value": box_obj.boxtype
      }
    }, [_vm._v(_vm._s(box_obj.boxtype) + "\n                                  ")])
  })], 2)])], 1)], 1), _vm._v(" "), _c('div', {
    staticClass: "col-md-3"
  }, [_c('b-form-fieldset', [_c('label', [_vm._v(_vm._s(_vm.$t('boxList.boxCondtion')))]), _vm._v(" "), _c('b-input-group', {
    attrs: {
      "left": "<i class='fa fa-cube'></i>"
    }
  }, [_c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.boxcondition),
      expression: "boxcondition"
    }],
    staticClass: "form-control",
    attrs: {
      "name": "boxcondition"
    },
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.boxcondition = $event.target.multiple ? $$selectedVal : $$selectedVal[0]
      }
    }
  }, [_c('option', {
    attrs: {
      "selected": "",
      "disabled": "",
      "value": ""
    }
  }, [_vm._v(_vm._s(_vm.$t('boxList.boxCondtionPlaceHolder')))]), _vm._v(" "), _vm._l((_vm.listBoxCondition), function(box_cn) {
    return _c('option', {
      domProps: {
        "value": box_cn
      }
    }, [_vm._v(_vm._s(box_cn))])
  })], 2)])], 1)], 1), _vm._v(" "), _c('div', {
    staticClass: "col-md-3"
  }, [_c('label', [_vm._v(_vm._s(_vm.$t('boxList.boxId')))]), _vm._v(" "), _c('b-input-group', {
    attrs: {
      "left": "<i class='fa fa-bookmark'></i>"
    }
  }, [_c('b-form-input', {
    attrs: {
      "type": "Number",
      "placeholder": _vm.$t('boxList.boxIdPlaceHolder'),
      "id": "pickingbox"
    },
    model: {
      value: (_vm.boxid),
      callback: function($$v) {
        _vm.boxid = $$v
      },
      expression: "boxid"
    }
  })], 1)], 1), _vm._v(" "), (_vm.boxcondition == 'Utilized') ? _c('div', {
    staticClass: "col-md-3"
  }, [_c('label', [_vm._v(_vm._s(_vm.$t('common.orderID')))]), _vm._v(" "), _c('b-input-group', {
    attrs: {
      "left": "<i class='fa fa-bookmark'></i>"
    }
  }, [_c('b-form-input', {
    attrs: {
      "type": "text",
      "placeholder": _vm.$t('common.orderIDPlaceholder')
    },
    model: {
      value: (_vm.orderid),
      callback: function($$v) {
        _vm.orderid = $$v
      },
      expression: "orderid"
    }
  })], 1)], 1) : _c('div', {
    staticClass: "col-md-3"
  })]), _vm._v(" "), _c('div', {
    staticClass: "form-group row"
  }, [_c('div', {
    staticClass: "col-md-12"
  }, [_c('div', {
    staticClass: "float-right"
  }, [_c('button', {
    staticClass: "btn btn-success",
    attrs: {
      "type": "button"
    },
    on: {
      "click": function($event) {
        _vm.getboxdata(2)
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-search"
  }), _vm._v("\n                                " + _vm._s(_vm.$t('inwardList.search')))]), _vm._v(" "), _c('button', {
    staticClass: "btn btn-danger",
    attrs: {
      "type": "reset"
    },
    on: {
      "click": _vm.resetFormData
    }
  }, [_c('i', {
    staticClass: "fa fa-refresh"
  }), _vm._v("\n                                " + _vm._s(_vm.$t('inwardList.reset')))])])])])])])])], 1)], 1), _vm._v(" "), _c('b-tab', {
    attrs: {
      "title": _vm.$t('boxList.packingBox')
    },
    on: {
      "click": function($event) {
        _vm.tabChanged(2)
      }
    }
  }, [_c('div', {
    staticClass: "card-header filter_main",
    staticStyle: {
      "display": "flex",
      "justify-content": "space-between"
    }
  }, [_c('i', {
    directives: [{
      name: "b-toggle",
      rawName: "v-b-toggle.collapse1",
      modifiers: {
        "collapse1": true
      }
    }],
    staticClass: " fa fa-filter filter",
    attrs: {
      "data-toggle": "collapse",
      "aria-expanded": "true"
    }
  }), _vm._v(" "), _c('a', {
    staticClass: "btn-setting d-sm-down-none",
    on: {
      "click": _vm.addNewBox
    }
  }, [_c('i', {
    staticClass: "fa fa-plus-square-o fa-lg",
    staticStyle: {
      "padding-right": "10px"
    }
  })])]), _vm._v(" "), _c('b-collapse', {
    attrs: {
      "visible": "",
      "id": "collapse1"
    }
  }, [_c('b-card', [_c('div', {
    staticClass: "card-body1"
  }, [_c('form', {
    staticClass: "form-horizontal",
    attrs: {
      "action": "",
      "method": "post"
    }
  }, [_c('div', {
    staticClass: "form-group row"
  }, [_c('div', {
    staticClass: "col-md-3"
  }, [_c('label', [_vm._v(_vm._s(_vm.$t('orders.salesChannel')))]), _vm._v(" "), _c('b-input-group', {
    attrs: {
      "left": "<i class='fa fa-window-maximize'></i>"
    }
  }, [_c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.searchchannel1),
      expression: "searchchannel1"
    }],
    staticClass: "form-control",
    attrs: {
      "name": "searchchannel1"
    },
    on: {
      "change": [function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.searchchannel1 = $event.target.multiple ? $$selectedVal : $$selectedVal[0]
      }, function($event) {
        _vm.getPackingBox()
      }]
    }
  }, [_c('option', {
    attrs: {
      "selected": "",
      "disabled": "",
      "value": ""
    }
  }, [_vm._v(_vm._s(_vm.$t('orders.salesChannelPlaceHolder')))]), _vm._v(" "), _vm._l((_vm.channellist), function(channel) {
    return _c('option', {
      domProps: {
        "value": channel.saleschannel
      }
    }, [_vm._v(_vm._s(channel.saleschannel))])
  })], 2)])], 1)]), _vm._v(" "), _c('div', {
    staticClass: "form-group row"
  }, [_c('div', {
    staticClass: "col-md-3"
  }, [_c('b-form-fieldset', [_c('label', [_vm._v(_vm._s(_vm.$t('boxList.boxType')))]), _vm._v(" "), _c('b-input-group', {
    attrs: {
      "left": "<i class='fa fa-cube'></i>"
    }
  }, [_c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.boxtypesearch),
      expression: "boxtypesearch"
    }],
    staticClass: "form-control",
    class: {
      'form-control': true,
      'error': _vm.errors.has('boxtypesearch')
    },
    attrs: {
      "id": "boxtypesearch"
    },
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.boxtypesearch = $event.target.multiple ? $$selectedVal : $$selectedVal[0]
      }
    }
  }, [_c('option', {
    attrs: {
      "selected": "",
      "disabled": "",
      "value": ""
    }
  }, [_vm._v(_vm._s(_vm.$t('boxList.boxTypePlaceHolder')))]), _vm._v(" "), _vm._l((_vm.listBoxtypeData), function(box_obj) {
    return _c('option', {
      domProps: {
        "value": box_obj.boxname
      }
    }, [_vm._v(_vm._s(box_obj.boxname) + "\n                                  ")])
  })], 2)])], 1)], 1), _vm._v(" "), _c('div', {
    staticClass: "col-md-3"
  }, [_c('b-form-fieldset', [_c('label', [_vm._v(_vm._s(_vm.$t('boxList.boxCondtion')))]), _vm._v(" "), _c('b-input-group', {
    attrs: {
      "left": "<i class='fa fa-cube'></i>"
    }
  }, [_c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.boxcondition),
      expression: "boxcondition"
    }],
    staticClass: "form-control",
    attrs: {
      "id": "boxcondition"
    },
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.boxcondition = $event.target.multiple ? $$selectedVal : $$selectedVal[0]
      }
    }
  }, [_c('option', {
    attrs: {
      "selected": "",
      "disabled": "",
      "value": ""
    }
  }, [_vm._v(_vm._s(_vm.$t('boxList.boxCondtionPlaceHolder')))]), _vm._v(" "), _vm._l((_vm.listBoxCondition), function(box_cn) {
    return _c('option', {
      domProps: {
        "value": box_cn
      }
    }, [_vm._v(_vm._s(box_cn))])
  })], 2)])], 1)], 1), _vm._v(" "), _c('div', {
    staticClass: "col-md-3"
  }, [_c('label', [_vm._v(_vm._s(_vm.$t('boxList.boxId')))]), _vm._v(" "), _c('b-input-group', {
    attrs: {
      "left": "<i class='fa fa-bookmark'></i>"
    }
  }, [_c('b-form-input', {
    attrs: {
      "type": "text",
      "placeholder": _vm.$t('boxList.boxIdPlaceHolder'),
      "id": "boxidpacking"
    },
    model: {
      value: (_vm.boxid),
      callback: function($$v) {
        _vm.boxid = $$v
      },
      expression: "boxid"
    }
  })], 1)], 1), _vm._v(" "), (_vm.boxcondition == 'Utilized') ? _c('div', {
    staticClass: "col-md-3"
  }, [_c('label', [_vm._v("Order ID ")]), _vm._v(" "), _c('b-input-group', {
    attrs: {
      "left": "<i class='fa fa-bookmark'></i>"
    }
  }, [_c('b-form-input', {
    attrs: {
      "type": "text",
      "placeholder": "Enter Order ID",
      "id": "orderid"
    },
    model: {
      value: (_vm.orderid),
      callback: function($$v) {
        _vm.orderid = $$v
      },
      expression: "orderid"
    }
  })], 1)], 1) : _c('div', {
    staticClass: "col-md-3"
  })]), _vm._v(" "), _c('div', {
    staticClass: "form-group row"
  }, [_c('div', {
    staticClass: "col-md-12"
  }, [_c('div', {
    staticClass: "float-right"
  }, [_c('button', {
    staticClass: "btn btn-success",
    attrs: {
      "type": "button",
      "id": "searchbtn"
    },
    on: {
      "click": function($event) {
        _vm.getboxdata(2)
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-search"
  }), _vm._v("\n                                " + _vm._s(_vm.$t('inwardList.search')))]), _vm._v(" "), _c('button', {
    staticClass: "btn btn-danger",
    attrs: {
      "type": "reset",
      "id": "resetbtn"
    },
    on: {
      "click": _vm.resetFormData
    }
  }, [_c('i', {
    staticClass: "fa fa-refresh"
  }), _vm._v("\n                                " + _vm._s(_vm.$t('inwardList.reset')))])])])])])])])], 1)], 1)], 1)], 1)]), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-12"
  }, [_c('div', {
    staticClass: "card-headerfrm"
  }, [_c('div', {
    staticClass: "form-group row expand",
    staticStyle: {
      "height": "20px"
    }
  }, [_c('div', {
    staticClass: "col-md-4 cardlistheader"
  }, [_c('h4', {
    staticClass: "header"
  }, [_c('i', {
    staticClass: "fa fa-bars barcolor",
    attrs: {
      "aria-hidden": "true"
    }
  }), _vm._v(" " + _vm._s(_vm.$t('boxList.boxListing')))])]), _vm._v(" "), _c('div', {
    staticClass: "col-md-4 cardlistheader"
  }), _vm._v(" "), (_vm.resultCount > 0) ? _c('div', {
    staticClass: "col-md-2 s1 o3 cardlistheader",
    staticStyle: {
      "display": "flex",
      "justify-content": "space-around",
      "margin-left": "-20px"
    }
  }, [_c('b', {
    staticStyle: {
      "color": "green"
    }
  }, [_c('i', {
    staticClass: "fa fa-time",
    attrs: {
      "aria-hidden": "true"
    }
  }), _vm._v(_vm._s(_vm.$t('product.table.count')) + " - " + _vm._s(_vm.resultCount))]), _vm._v(" "), (_vm.download && _vm.listboxdata.length > 0 && _vm.boxids.length > 0) ? _c('div', {
    staticClass: "col-md-2 s2 o4 ",
    staticStyle: {
      "margin-top": "-10px"
    }
  }, [_c('button', {
    staticClass: "btn btn-primary",
    on: {
      "click": function($event) {
        $event.preventDefault();
        _vm.printBoxsticker()
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-location-arrow fa-lg"
  }), _vm._v("\n                " + _vm._s(_vm.$t('inwardList.printData.printBarcode.printBtn')) + "\n              ")])]) : _vm._e()]) : _vm._e(), _vm._v(" "), (_vm.download && _vm.listboxdata.length > 0) ? _c('div', {
    staticClass: "col-md-2 s2 o4 "
  }, [_c('button', {
    staticClass: "btn btn-info downloadbutton",
    attrs: {
      "type": "button",
      "disabled": _vm.isLoading
    },
    on: {
      "click": function($event) {
        _vm.Choosetype(1)
      }
    }
  }, [_vm._v("  " + _vm._s(_vm.$t('printProductDetails.download')))])]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "col-md-1 ss o4 csv"
  }, [(_vm.show && _vm.listboxdata.length) ? _c('button', {
    staticClass: "btn btn-info downloadbutton",
    attrs: {
      "disabled": _vm.isLoading,
      "title": "Download CSV"
    },
    on: {
      "click": function($event) {
        _vm.getboxdata(1)
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-download"
  })]) : _vm._e()]), _vm._v(" "), (!_vm.limitExeed && _vm.show && _vm.listboxdata.length > 0) ? _c('div', {
    staticClass: "col-md-1 ss o4"
  }, [_c('download-excel', {
    staticClass: "btn btn-info downloadbutton ",
    attrs: {
      "before-generate": _vm.startDownload,
      "before-finish": _vm.finishDownload,
      "header": _vm.dataFilter2,
      "title": "Download Excel",
      "data": _vm.listReportDataforxls,
      "fields": _vm.csvFieldsForXls,
      "worksheet": "MyWorksheet",
      "name": _vm.reportname
    }
  }, [_c('i', {
    staticClass: "fa fa-file-excel-o",
    attrs: {
      "aria-hidden": "true"
    }
  })])], 1) : _vm._e()]), _vm._v(" "), _c('loader', {
    attrs: {
      "isLoading": _vm.isLoading
    }
  }), _vm._v(" "), _c('div', {
    staticStyle: {
      "overflow": "auto"
    }
  }, [_c('table', {
    staticClass: "table-bordered table-hover tbl datatables table",
    staticStyle: {
      "width": "100%"
    },
    attrs: {
      "id": "my-table"
    }
  }, [_c('thead', [_c('tr', {
    staticClass: "text-primary "
  }, [(_vm.packingbox) ? _c('th', {
    directives: [{
      name: "",
      rawName: "v-"
    }],
    staticClass: "text-center tableheader",
    attrs: {
      "bind-title": "Select All"
    }
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.selectAll),
      expression: "selectAll"
    }],
    attrs: {
      "type": "checkbox"
    },
    domProps: {
      "checked": Array.isArray(_vm.selectAll) ? _vm._i(_vm.selectAll, null) > -1 : (_vm.selectAll)
    },
    on: {
      "change": _vm.selectAllCheckbox,
      "__c": function($event) {
        var $$a = _vm.selectAll,
          $$el = $event.target,
          $$c = $$el.checked ? (true) : (false);
        if (Array.isArray($$a)) {
          var $$v = null,
            $$i = _vm._i($$a, $$v);
          if ($$el.checked) {
            $$i < 0 && (_vm.selectAll = $$a.concat($$v))
          } else {
            $$i > -1 && (_vm.selectAll = $$a.slice(0, $$i).concat($$a.slice($$i + 1)))
          }
        } else {
          _vm.selectAll = $$c
        }
      }
    }
  })]) : _vm._e(), _vm._v(" "), _c('th', {
    staticClass: "text-center tableheader"
  }, [_c('b', [_vm._v(" " + _vm._s(_vm.$t('boxList.boxId')) + " ")])]), _vm._v(" "), _c('th', {
    staticClass: "text-center tableheader"
  }, [_c('b', [_vm._v(_vm._s(_vm.$t('boxList.boxType')))])]), _vm._v(" "), _c('th', {
    staticClass: "text-center tableheader"
  }, [_c('b', [_vm._v(_vm._s(_vm.$t('boxList.length')))])]), _vm._v(" "), _c('th', {
    staticClass: "text-center tableheader"
  }, [_c('b', [_vm._v(" " + _vm._s(_vm.$t('boxList.breadth')) + " ")])]), _vm._v(" "), _c('th', {
    staticClass: "text-center tableheader"
  }, [_c('b', [_vm._v(_vm._s(_vm.$t('boxList.height')))])]), _vm._v(" "), (!_vm.packingbox) ? _c('th', {
    staticClass: "text-center tableheader"
  }, [_c('b', [_vm._v(_vm._s(_vm.$t('boxList.batchNumber')))])]) : _vm._e(), _vm._v(" "), _c('th', {
    staticClass: "text-center tableheader"
  }, [_c('b', [_vm._v(_vm._s(_vm.$t('boxList.boxUtilization')))])]), _vm._v(" "), _c('th', {
    staticClass: "text-center tableheader"
  }, [_c('b', [_vm._v(_vm._s(_vm.$t('boxList.shipmentId')) + " ")])])])]), _vm._v(" "), _c('tbody', [(_vm.resultCount == 0) ? _c('tr', [_c('td', {
    attrs: {
      "colspan": "8",
      "align": "center"
    }
  }, [_vm._v(_vm._s(_vm.$t('common.noRecordFound')))])]) : _vm._e(), _vm._v(" "), _vm._l((_vm.listboxdata), function(data, index) {
    return _c('tr', [(_vm.packingbox) ? _c('td', {
      staticClass: "text-center "
    }, [_c('input', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (_vm.boxids),
        expression: "boxids"
      }],
      attrs: {
        "type": "checkbox"
      },
      domProps: {
        "value": data.boxid,
        "checked": Array.isArray(_vm.boxids) ? _vm._i(_vm.boxids, data.boxid) > -1 : (_vm.boxids)
      },
      on: {
        "__c": function($event) {
          var $$a = _vm.boxids,
            $$el = $event.target,
            $$c = $$el.checked ? (true) : (false);
          if (Array.isArray($$a)) {
            var $$v = data.boxid,
              $$i = _vm._i($$a, $$v);
            if ($$el.checked) {
              $$i < 0 && (_vm.boxids = $$a.concat($$v))
            } else {
              $$i > -1 && (_vm.boxids = $$a.slice(0, $$i).concat($$a.slice($$i + 1)))
            }
          } else {
            _vm.boxids = $$c
          }
        }
      }
    })]) : _vm._e(), _vm._v(" "), _c('td', {
      staticClass: "text-center ",
      attrs: {
        "scope": "row"
      }
    }, [_c('strong', [_vm._v(_vm._s(data.boxid))])]), _vm._v(" "), _c('td', {
      staticClass: "text-center "
    }, [_vm._v(_vm._s(data.boxtype))]), _vm._v(" "), _c('td', {
      staticClass: "text-center "
    }, [_vm._v(_vm._s(data.length))]), _vm._v(" "), _c('td', {
      staticClass: "text-center "
    }, [_vm._v(_vm._s(data.width))]), _vm._v(" "), _c('td', {
      staticClass: "text-center "
    }, [_vm._v(_vm._s(data.height))]), _vm._v(" "), (!_vm.packingbox) ? _c('td', {
      staticClass: "text-center ",
      attrs: {
        "scope": "row"
      }
    }, [_vm._v(_vm._s(data.boxbatchid))]) : _vm._e(), _vm._v(" "), _c('td', {
      staticClass: "text-center "
    }, [_vm._v(_vm._s(data.order_id))]), _vm._v(" "), _c('td', {
      staticClass: "text-center "
    }, [_vm._v(_vm._s(data.shipment_id))])])
  })], 2)])]), _c('br'), _vm._v(" "), (_vm.totalPage > 0) ? _c('pagination', {
    attrs: {
      "total-pages": _vm.totalPage,
      "total": _vm.totalRows,
      "per-page": _vm.pageLimit,
      "current-page": _vm.currentPage
    },
    on: {
      "pagechanged": _vm.onPageChange
    }
  }) : _vm._e()], 1)])])]), _vm._v(" "), _c('b-modal', {
    attrs: {
      "size": "modal-lg"
    },
    on: {
      "ok": function($event) {
        _vm.addboxemodal = false
      }
    },
    model: {
      value: (_vm.addboxemodal),
      callback: function($$v) {
        _vm.addboxemodal = $$v
      },
      expression: "addboxemodal"
    }
  }, [_c('form', {
    on: {
      "submit": function($event) {
        $event.preventDefault();
        _vm.onSubmit($event)
      }
    }
  }, [_c('div', {
    staticClass: "form-group"
  }, [_c('b-card', [_c('div', {
    slot: "header"
  }, [(_vm.boxcreate == 'add' && !_vm.packingbox) ? _c('span', {
    staticClass: "mdltitle"
  }, [_vm._v(_vm._s(_vm.$t('boxList.createpickingBox')))]) : _vm._e(), _vm._v(" "), (_vm.boxcreate == 'add' && _vm.packingbox) ? _c('span', {
    staticClass: "mdltitle"
  }, [_vm._v(_vm._s(_vm.$t('boxList.createpackingBox')))]) : _vm._e(), _vm._v(" "), _c('button', {
    staticClass: "close",
    attrs: {
      "type": "button",
      "aria-label": "Close"
    },
    on: {
      "click": _vm.closeaddboxemodal
    }
  }, [_vm._v("×")])]), _vm._v(" "), _c('div', {
    staticClass: "col-md-8"
  }, [_c('b-form-fieldset', [_c('label', [_vm._v(_vm._s(_vm.$t('boxList.boxType')))]), _c('span', {
    staticClass: "text-danger"
  }, [_vm._v("*")]), _vm._v(" "), _c('b-input-group', {
    attrs: {
      "left": "<i class='fa fa-cube'></i>"
    }
  }, [_c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.boxtype),
      expression: "boxtype"
    }, {
      name: "validate",
      rawName: "v-validate",
      value: ({
        required: true
      }),
      expression: "{required: true}"
    }],
    staticClass: "form-control",
    class: {
      'form-control': true,
      'error': _vm.errors.has('boxtype')
    },
    attrs: {
      "name": "boxtype"
    },
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.boxtype = $event.target.multiple ? $$selectedVal : $$selectedVal[0]
      }
    }
  }, [_c('option', {
    attrs: {
      "selected": "",
      "disabled": "",
      "value": ""
    }
  }, [_vm._v(_vm._s(_vm.$t('boxList.boxTypePlaceHolder')))]), _vm._v(" "), _vm._l((_vm.listBoxtypeData), function(box_obj) {
    return (!_vm.packingbox) ? _c('option', {
      domProps: {
        "value": box_obj.boxtype
      }
    }, [_vm._v(_vm._s(box_obj.boxtype))]) : _vm._e()
  }), _vm._v(" "), _vm._l((_vm.listBoxtypeData), function(box_obj) {
    return (_vm.packingbox) ? _c('option', {
      domProps: {
        "value": box_obj.boxname
      }
    }, [_vm._v(_vm._s(box_obj.boxname))]) : _vm._e()
  })], 2)]), _vm._v(" "), _c('span', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.errors.has('boxtype')),
      expression: "errors.has('boxtype')"
    }],
    staticClass: "text-danger"
  }, [_vm._v(_vm._s(_vm.$t('boxList.boxTypeError')) + ".\n              ")])], 1)], 1), _vm._v(" "), _c('div', {
    staticClass: "col-md-8"
  }, [_c('b-form-fieldset', [_c('label', [_vm._v(_vm._s(_vm.$t('boxList.boxQuantity')))]), _c('span', {
    staticClass: "text-danger"
  }, [_vm._v("*")]), _vm._v(" "), _c('b-input-group', {
    attrs: {
      "left": "<i class='fa fa-industry'></i>"
    }
  }, [_c('b-form-input', {
    directives: [{
      name: "validate",
      rawName: "v-validate",
      value: ('required'),
      expression: "'required'"
    }],
    class: {
      'form-control': true,
      'error': _vm.errors.has('quantity')
    },
    attrs: {
      "type": "Number",
      "placeholder": _vm.$t('boxList.boxQuantityPlaceholder'),
      "name": "quantity",
      "id": "quantity"
    },
    model: {
      value: (_vm.quantity),
      callback: function($$v) {
        _vm.quantity = $$v
      },
      expression: "quantity"
    }
  })], 1), _vm._v(" "), _c('span', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.errors.has('quantity')),
      expression: "errors.has('quantity')"
    }],
    staticClass: "text-danger"
  }, [_vm._v(_vm._s(_vm.$t('boxList.boxQuantityError')) + ".\n              ")])], 1)], 1), _vm._v(" "), _c('div', {
    staticClass: "form-group row"
  }, [_c('div', {
    staticClass: "col-md-12"
  }, [_c('div', {
    staticClass: "float-right"
  }, [(!_vm.packingbox) ? _c('button', {
    staticClass: "btn btn-primary ",
    attrs: {
      "type": "submit",
      "variant": "primary",
      "disabled": _vm.isLoading
    },
    on: {
      "click": _vm.savebox
    }
  }, [_c('i', {
    staticClass: "fa fa-save"
  }), _vm._v(_vm._s(_vm.$t('boxList.createpickingBox')))]) : _vm._e(), _vm._v(" "), (_vm.packingbox) ? _c('button', {
    staticClass: "btn btn-primary ",
    attrs: {
      "type": "submit",
      "variant": "primary",
      "disabled": _vm.isLoading
    },
    on: {
      "click": _vm.savebox
    }
  }, [_c('i', {
    staticClass: "fa fa-save"
  }), _vm._v(_vm._s(_vm.$t('boxList.createpackingBox')))]) : _vm._e(), _vm._v(" "), _c('button', {
    staticClass: "btn btn-danger",
    attrs: {
      "type": "button",
      "size": "sm"
    },
    on: {
      "click": _vm.closeaddboxemodal
    }
  }, [_c('i', {
    staticClass: "fa fa-ban"
  }), _vm._v(" " + _vm._s(_vm.$t('common.cancelBtn')))]), _vm._v("  \n          ")])])])])], 1)])])], 1)
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
     require("vue-hot-reload-api").rerender("data-v-7be2959c", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-7be2959c","hasScoped":true}!./src/views/components/boxtype/boxtype.component.html
// module id = 840
// module chunks = 0